/* eslint-disable react-hooks/exhaustive-deps */
import { STATUS_BUILD } from "components/Status/types"
import { formatDate } from "helpers/utils"
import { ProjectBuildDetail } from "../types"
import React, { useState } from "react"
import { Avatar } from "components/Avatar"
import { useWindowSize } from "helpers/hooks"

interface Props {
  syncHistories: any
}

export interface HeaderTableBuild {
  name: string
  field: string
  style?: React.CSSProperties
}
export const TableSyncHistories = (props: Props) => {
  const { isMobile } = useWindowSize()
  const { syncHistories } = props
  const [headers, setHeaders] = useState<HeaderTableBuild[]>([
    {
      name: "#",
      field: "index",
      style: {
        width: 50,
        minWidth: 50,
      },
    },
    {
      name: "From",
      field: "from",
      style: {
        width: "auto",
      },
    },
    {
      name: "To",
      field: "to",
      style: {
        width: "auto",
      },
    },
    {
      name: "Type",
      field: "type",
      style: {
        width: 100,
        minWidth: 100,
      },
    },
    {
      name: "Created By",
      field: "created_by",
      style: {
        width: 150,
        minWidth: 150,
      },
    },
    {
      name: "Created",
      field: "created_at",
      style: {
        width: 180,
        minWidth: 180,
      },
    },
  ])

  const renderTableBody = (
    header: HeaderTableBuild,
    value: any,
    index: number
  ) => {
    switch (header.field) {
      case "index":
        return index + 1
      case "created_at":
        return (
          <p
            className="font-normal"
            style={{
              fontSize: 13,
              lineHeight: "22px",
              color: "#7A7A7A",
            }}
          >
            {value[header.field]
              ? formatDate(value[header.field], "DD MMM yyyy - HH:mm A")
              : "No update"}
          </p>
        )
      case "type":
        return (
          <p
            className="font-semibold"
            style={{
              color: "#56A012",
            }}
          >
            {value[header.field]}
          </p>
        )
      case "created_by":
        return (
          <div className="flex items-center gap-[8px]">
            <Avatar
              width="24px"
              height="24px"
              name={value.user_fullname}
              avatar={value.user_avatar}
            />
            <p>{value.user_fullname || value.user_email}</p>
          </div>
        )
      default:
        return value[header.field]
    }
  }

  const renderBackgroundColorTable = (
    isArchived: boolean,
    oldIndex: number
  ) => {
    if (isArchived) {
      return "neutral3"
    }
    if (oldIndex % 2 === 0) {
      return "grayWhite"
    }
    return "white"
  }

  return (
    <div
      className="bg-white flex w-full mr-6 overflow-auto"
      style={{
        border: "1px solid #E4E4E4",
        borderRadius: 6,
        paddingBottom: 2,
      }}
    >
      <table className="w-full">
        <thead>
          <tr>
            {headers.map((header: HeaderTableBuild, idx: number) => (
              <th
                className="pl-3 font-semibold min-h-48-custom h-12"
                style={{
                  fontSize: 14,
                  lineHeight: "24px",
                  color: "#111111",
                  textAlign: "left",
                  ...header.style,
                }}
                key={idx}
              >
                {header.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {syncHistories.length ? (
            syncHistories.map((el: ProjectBuildDetail, index: number) => (
              <tr
                key={index}
                className={`${
                  el.status === STATUS_BUILD.DELETED
                    ? "bg-table-row-delete-element bg-neutral3"
                    : `bg-${renderBackgroundColorTable(
                        Boolean(el.is_archived),
                        index
                      )}`
                }`}
              >
                {headers.map((header: HeaderTableBuild, idx: number) => (
                  <td
                    className="pl-3 py-1 font-normal min-h-48-custom h-12 whitespace-nowrap"
                    style={{
                      fontSize: 13,
                      lineHeight: "24px",

                      color: Boolean(el.is_archived) ? "#C7C7C7" : "#111111",
                      ...header.style,
                    }}
                    key={idx}
                  >
                    {renderTableBody(header, el, index)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td
                className="px-3 font-normal min-h-48-custom"
                style={{
                  fontSize: 14,
                  lineHeight: "24px",
                  color: "#111111",
                  textAlign: "center",
                }}
                colSpan={headers.length}
              >
                No data
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
